import { useAtom } from 'jotai';
import { useStore } from 'jotai/react';
import { useEffect, useRef } from 'react';
import { stageModeAtom, stageRefAtom } from '@/store/boardAtoms';
/**
 * Хук для синхронизации draggable состояния элементов с режимом Stage
 * Обновляет draggable напрямую через Konva API для избежания перерендера React компонентов
 */
export const useStageDraggableSync = () => {
    const store = useStore();
    const [stageMode] = useAtom(stageModeAtom);
    const elementDraggableDefaultsRef = useRef(new Map());
    // Обновляем draggable напрямую через Konva API для всех элементов при изменении режима
    // Это позволяет избежать перерендера React компонентов
    useEffect(() => {
        var _a;
        const stage = store.get(stageRefAtom);
        if (!stage)
            return;
        // Находим все элементы по селектору .element
        const elements = stage.find('.element');
        for (const node of elements) {
            // Получаем ID элемента из атрибута id (формат: "node-{id}")
            const nodeId = node.id();
            if (!nodeId || !nodeId.startsWith('node-'))
                continue;
            const elementId = Number(nodeId.replace('node-', ''));
            if (isNaN(elementId))
                continue;
            // Если элемента нет в ref - сохраняем текущее значение draggable как дефолт
            if (!elementDraggableDefaultsRef.current.has(elementId)) {
                const currentDraggable = node.draggable();
                elementDraggableDefaultsRef.current.set(elementId, currentDraggable);
            }
            // Получаем исходное значение draggable из ref
            const originalDraggable = (_a = elementDraggableDefaultsRef.current.get(elementId)) !== null && _a !== void 0 ? _a : false;
            // Вычисляем новое значение draggable
            // Если режим не 'select', то draggable=false, иначе возвращаем исходное значение
            const newDraggable = stageMode === 'select' ? originalDraggable : false;
            // Обновляем draggable напрямую через Konva API
            if (node.draggable() !== newDraggable) {
                node.draggable(newDraggable);
            }
        }
    }, [stageMode, store]);
};
